import PosthogService from '~/services/posthog/PosthogService';
import type { TInvitePopupSource } from './types';

export interface IPopUpViewedPayload {
  source: TInvitePopupSource;
}

/**
 * Fires when the Invite popup is viewed
 * Event: dental_portal:invite:pop_up_viewed
 */
export function firePopUpViewed(payload: IPopUpViewedPayload): void {
  PosthogService.getInstance().track('dental_portal:invite:pop_up_viewed', {
    source: payload.source,
  });
}
